<template>
  <div v-if="hasMeta" class="promotion-meta">
    <span v-if="hasOriginalCost" class="old-cost">
      <span>ราคาเดิม</span>
      <span class="old-cost-value">{{ originalCostDisplay }}</span>
    </span>
    <span v-if="hasPromotionPeriod" class="row-promotion-period">
      ช่วงโปร {{ promotionPeriod }}
    </span>
  </div>
</template>

<script>
import { isNil } from "ramda";
import { formatServicePriceDisplay } from "../utils/servicePrice";

export default {
  props: {
    originalCost: {
      type: [Number, String],
      default: null,
    },
    promotionPeriod: {
      type: String,
      default: null,
    },
    showOriginalCost: {
      type: Boolean,
      default: true,
    },
    showPromotionPeriod: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasOriginalCost() {
      return this.showOriginalCost && !isNil(this.originalCost);
    },
    hasPromotionPeriod() {
      return this.showPromotionPeriod && !!this.promotionPeriod;
    },
    hasMeta() {
      return this.hasOriginalCost || this.hasPromotionPeriod;
    },
    originalCostDisplay() {
      return formatServicePriceDisplay(this.originalCost);
    },
  },
};
</script>

<style lang="scss" scoped>
.promotion-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
  flex-wrap: wrap;
}

.old-cost {
  display: inline-flex;
  gap: 4px;
  color: #7d8288;
  font-size: 12px;
  line-height: 1.3;
}

.old-cost-value {
  text-decoration: line-through;
}

.row-promotion-period {
  color: #8a5a13;
  font-size: 12px;
  line-height: 1.3;
}
</style>
